import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { MarketoObjectDataset } from 'app/model/dataset/marketo.dataset';
import { Metamodel } from 'app/model/base/model';
import { MarketoLinkedService } from 'app/model/linkedservice/marketo.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const marketoObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(MarketoObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Marketo_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(MarketoLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-marketo'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
